import { makeObservable } from 'mobx';

import { Filtro } from './Filtro';

export default class FiltroAnotacoesComplementares extends Filtro {
    static LABEL_VALOR_VAZIO = '----- VAZIO OU EM BRANCO -----';

    tipo = 'selecao';

    exibicao = 'select';

    selecaoMultipla = true;

    constructor(props) {
        super(props);
        makeObservable(this, {
            tipo: true,
            exibicao: true,
            selecaoMultipla: true,
            label: true,
            getValorOpcao: true,
            equals: true,
            getDescricao: true
        });
    }

    get label() {
        return 'Anotações complementares';
    }

    getValorOpcao(registro) {
        return (
            registro.informacaoProcessoSalaSessao?.complementoAnotacoes?.trim() ||
            FiltroAnotacoesComplementares.LABEL_VALOR_VAZIO
        );
    }

    equals(valor1, valor2) {
        return valor1?.trim() === valor2?.trim();
    }

    getDescricao(valor) {
        if (!valor) {
            return FiltroAnotacoesComplementares.LABEL_VALOR_VAZIO;
        }

        const QUANTIDADE_MAX_CARACTERES_A_EXIBIR = 150;
        const tamanho = valor.length;
        return tamanho <= QUANTIDADE_MAX_CARACTERES_A_EXIBIR
            ? valor
            : valor.slice(0, QUANTIDADE_MAX_CARACTERES_A_EXIBIR) + '... (' + tamanho + ' caracteres)';
    }
}
